<template>
  <header :class="{'fixed':headerTopHide, 'lightheader': $route.path == 1}">
    <div class="header-top d-none d-lg-block" :class="{'hide':headerTopHide}">
      <b-container>
        <b-row align-v="center">
          <b-col col lg="4" class="d-flex align-items-center justify-content-start">
            <a
              class="header-contact"
              href="#"
              @click.prevent
            >{{contacts && contacts.hF_contact.adress}}</a>
          </b-col>
          <b-col lg="3" class="d-none d-lg-flex align-items-center justify-content-start">
            <a
              class="header-contact"
              :href="`mailto:${contacts && contacts.hF_contact.email}`"
            >{{contacts && contacts.hF_contact.email}}</a>
          </b-col>
          <b-col lg="3" class="d-none d-lg-flex align-items-center justify-content-start">
            <a
              class="header-contact"
              href="#"
              @click.prevent
            >{{contacts && contacts.hF_contact.shedule}}</a>
          </b-col>
          <b-col lg="2" class="d-none d-lg-flex align-items-center justify-content-end">
            <a
              class="header-contact"
              :href="`tel:${contacts && contacts.hF_contact.phone}`"
            >{{contacts && contacts.hF_contact.phone}}</a>
          </b-col>
        </b-row>
      </b-container>
    </div>
    <div class="header-menu">
      <b-container>
        <b-row align-v="center">
          <b-col col lg="3">
            <router-link class="header-menu_link" :to="'/'" tag="a">
              <img class="header-logo" src="@/assets/img/main_logo.svg" alt />
            </router-link>
          </b-col>
          <b-col cols="7" class="d-none d-lg-block">
            <div class="desktop-menu d-flex align-items-center justify-content-center">
              <router-link
                class="header-menu_link pr-5"
                :to="item.url.replace('/api', '')"
                tag="a"
                v-for="(item,index) in data"
                :key="index"
                v-if="item.url.replace('/api', '') !== '/services/' && item.url.replace('/api', '') !== '/objects/'"
              >{{item.title}}</router-link>
              <router-link
                class="header-menu_link"
                :to="{path: item.url.replace('/api', ''), query:{city: 'Тюмень' ,serv: 'Монтаж'}}"
                tag="a"
                v-else-if="item.url.replace('/api', '') === '/objects/' "
              >{{item.title}}</router-link>

              <router-link
                :to="{path: item.url.replace('/api', ''), query: {}}"
                class="header-menu_link pr-5"
                id="services"
                href="#"
                @click.prevent
                v-else-if="item.url.replace('/api', '') === '/services/'"
              >
                {{item.title}}
                <svg
                  :class="{'popOpen' : servPop }"
                  width="10"
                  height="7"
                  viewBox="0 0 10 7"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path d="M1 1L5 5L9 1" stroke="#191919" stroke-width="1.5" />
                </svg>
                <b-popover
                  @show="servPop = true"
                  @hide="servPop=false"
                  ref="pop"
                  target="services"
                  triggers="hover"
                  placement="bottom"
                  custom-class="services-popover"
                >
                  <div
                    class="services-popover_content d-flex flex-column align-items-start justify-content-center"
                  >
                    <router-link
                    style="font-size: 16px; font-weight: 400;"
                      class="header-menu_link"
                      :to="{ path: data.services.url.replace('/api', ''), query: { type: item.title }}"
                      tag="a"
                      v-for="(item,index) in data.services && data.services.servicescat"
                      :key="index"
                    >{{item.title}}</router-link>
                  </div>
                </b-popover>
              </router-link>
            </div>
          </b-col>
          <b-col cols="2" class="d-none d-lg-flex">
            <div class="button-container" @click="$root.showCallback()">
              <slot name="button"></slot>
            </div>
          </b-col>
          <b-col cols="auto" class="d-block d-lg-none">
            <div
              class="hamburger hamburger--emphatic"
              :class="{'is-active': isActive}"
              @click="isActive= !isActive"
              tabindex="0"
              aria-label="Menu"
              role="button"
              aria-controls="navigation"
            >
              <div class="hamburger-box">
                <div class="hamburger-inner"></div>
              </div>
            </div>
          </b-col>
        </b-row>
      </b-container>
    </div>
    <div
      class="mobile-menu d-flex flex-column justify-content-start d-lg-none"
      :class="{'show':isActive}"
    >
      <router-link
        :to="item.url.replace('/api', '')"
        class="mobile-menu_link mobile-services d-flex flex-column align-items-start justify-content-between w-100"
        tag="a"
        v-for="(item,index) in data"
        :key="index"
        @click.native="isActive=false"
      >{{item.title}}
        <div
          class="subcat d-flex flex-column justify-content-start align-items-start mt-3 ml-2"
          v-if="item.url.replace('/api', '') === '/services/'">
            <router-link
            class="mb-2"
            :to="{ path: data.services.url.replace('/api', ''), query: { type: link.title }}"
            tag="a"
            v-for="(link,i) in data.services && data.services.servicescat"
            :key="i"
            >{{link.title}}</router-link>
        </div>
      </router-link>
    
      <div class="phone">
        <a :href="`tel:${contacts && contacts.hF_contact.phone}`">
            {{contacts && contacts.hF_contact.phone}}</a>
      </div>
    </div>
  </header>
</template>


<script>
const axios = require("axios");
const OFFSET = 60;
export default {
  props: {
    logolink: String
  },
  data() {
    return {
      data: {},
      contacts: null,
      dataContacts: {},
      isActive: false,
      lastScrollPosition: 0,
      scrollValue: 0,
      headerTopHide: false,
      servPop: false
    };
  },
  mounted() {
    this.lastScrollPosition = window.pageYOffset;
    window.addEventListener("scroll", this.onScroll);
  },
  beforeCreate() {
    axios
      .get(`${this.$root.routLink}/?ajax&act=header-links`, {
        responseType: "json"
      })
      .then(({ data }) => {
        let data1 = JSON.parse(data.addons);
        this.data = data1;
      });
    axios
      .get(`${this.$root.routLink}/?ajax&act=header-contacts`, {
        responseType: "json"
      })
      .then(({ data }) => {
        this.contacts = JSON.parse(data.addons);
      });
  },
  beforeDestroy() {
    window.removeEventListener("scroll", this.onScroll);
  },
  methods: {
    onScroll() {
      this.servPop = false;

      if (window.pageYOffset > 100) {
        this.headerTopHide = true;
      } else {
        this.headerTopHide = false;
      }

      // this.showNavbar = window.pageYOffset < this.lastScrollPosition
      // this.lastScrollPosition = window.pageYOffset
    },
    ddClick() {
      this.$refs.dd.click();
    }
  }
};
</script>

<style lang="scss" scoped>
header {
  width: 100%;
  max-width: 100%;

  position: fixed;
  top: 0;
  z-index: 100;

  transition: all 0.3s ease-in-out;
  @media only screen and (max-width: $md),
    only screen and (max-device-width: $md) {
    height: 72px;
  }
  &.fixed {
    background-color: $defaultColor;
  }
  .header-top {
    background: $defaultColor;
    transition: all 0.5s ease-in-out;
    overflow: hidden;
    height: 50px;
    border-bottom: 1px solid $activeColor;
    &.hide {
      height: 0px;
      border-bottom: 0px solid $activeColor;
    }
    .row {
      height: 50px;
    }

    .header-contact {
      font-style: normal;
      font-weight: 500;
      font-size: 12px;
      line-height: 18px;
      color: $secondFontColor;
    }
  }

  .hamburger {
    display: block;
    .hamburger-inner,
    .hamburger-inner:before,
    .hamburger-inner:after {
    }
    &.is-active {
      .hamburger-inner {
        animation: none;
      }
    }
  }

  .header-menu {
    padding: 10px 0;
    z-index: -1;
    transition: transform 0.5s ease-in-out;
    @media only screen and (max-width: $md),
      only screen and (max-device-width: $md) {
      padding: 0;
      height: 72px;
      background-color: $defaultColor;
      .row {
        height: 72px;
      }
    }

    &_link {
      font-weight: 500;
      font-size: 14px;
      line-height: 18px;
      transition: all 0.3s ease-in-out;
      svg {
        transition: all 0.3s ease-in-out;
        &.popOpen {
          transform: rotate(180deg);
        }
        path {
          transition: all 0.3s ease-in-out;
        }
      }
      &:hover {
        color: $activeColor !important;
        svg {
          path {
            stroke: $activeColor !important;
          }
        }
      }
    }
    .header-logo {
      max-width: 100%;
      max-height: 100%;
    }
  }
  .button-container {
    width: 100%;
    height: 40px;
  }

  .mobile-menu {
    position: absolute;
    right: 0;
    width: 320px;
    height: calc(100vh - 72px);
    background: $bg2Color;
    padding: 40px 15px;
    float: right;
    transform: translateX(100%);
    transition: transform 0.3s ease-in-out;
    &.show {
      transform: translateX(0);
    }
    &_link {
      padding-bottom: 10px;
      margin-bottom: 10px;
      position: relative;

      font-weight: 500;
      font-size: 16px;
      line-height: 20px;

      color: $mainFontColor;

      border-bottom: 1px solid #dfdfdf;
    }
    .tel {
      font-style: normal;
      font-weight: 500;
      font-size: 26px;
      line-height: 150%;
      color: #aeb3c2;
      margin-bottom: 20px;
    }
    .phone {
      a {
      color: $activeColor;
      font-weight: 500;
      margin-top: 25px;
      transition: all 0.3s ease-in-out;
      &:hover {
        color: $darkColor;
      }
      }
    }
  }
}
</style>
<style lang="scss">
.popover {
  border: none !important;
  & > .arrow {
    &:before,
    &:after {
      border-right-color: transparent !important;
      border-bottom-color: $defaultColor !important;
    }
  }
}

.services-popover .popover-body {
  padding: 10px 15px;
  background: #ffffff;
  /*box-shadow: 0px 0px 44px rgba(0, 0, 0, 0.1);*/
  border-radius: 6px;
  border: none !important;
  box-shadow: none;

  .services-popover_content a {
    font-weight: 500;
    font-size: 12px;
    line-height: 15px;
    transition: all 0.3s ease-in-out;
    /*identical to box height */

    color: $mainFontColor;

    &:not(:last-child) {
      margin-bottom: 10px;
    }
    &:hover {
      color: $activeColor;
    }
  }
}

.router-link-exact-active,
#services.router-link-active,
.mobile-services.router-link-active {
  color: $activeColor !important;
  svg {
    path {
      stroke: $activeColor !important;
    }
  }
}
</style>